import { createContext, useContext, useState, useCallback } from 'react';
import CalendlyEmbedModal from '../components/CalendlyEmbedModal';

const CalendlyEmbedContext = createContext(null);

export function CalendlyEmbedProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState('');

  const openCalendly = useCallback((calendlyUrl) => {
    if (!calendlyUrl || typeof calendlyUrl !== 'string') return;
    const trimmed = calendlyUrl.trim();
    if (!trimmed.startsWith('http')) return;
    setUrl(trimmed);
    setOpen(true);
  }, []);

  const closeCalendly = useCallback(() => {
    setOpen(false);
    setUrl('');
  }, []);

  return (
    <CalendlyEmbedContext.Provider value={{ openCalendly, closeCalendly }}>
      {children}
      <CalendlyEmbedModal isOpen={open} calendlyUrl={url} onClose={closeCalendly} />
    </CalendlyEmbedContext.Provider>
  );
}

export function useCalendlyEmbed() {
  const ctx = useContext(CalendlyEmbedContext);
  if (!ctx) {
    throw new Error('useCalendlyEmbed must be used within CalendlyEmbedProvider');
  }
  return ctx;
}
